// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vl0K","col":"styles_col__1Zjqy"};